export default __webpack_public_path__ + "static/rm-full-logo-8743b0e59d67ff58acde17bd13a06cf7.svg";